import { useId as useId$1, computed, toValue } from "vue";
import { w as withBvnPrefix } from "./keys-CFfh7DXf.mjs";
const useId = (id, suffix) => {
  const genId = useId$1();
  return computed(() => toValue(id) || withBvnPrefix(genId || "", suffix));
};
export {
  useId as u
};
//# sourceMappingURL=useId-BHgDiJzr.mjs.map
